import Typography from '@mui/material/Typography'
import React from 'react'

const NotFound: React.FC = () => {
  return (
    <Typography variant="h2" sx={{ color: (theme) => theme.palette.colors?.negativeRed }}>
      404, Route not found!!
    </Typography>
  )
}

export default NotFound
